export default __webpack_public_path__ + "static/media/searchIcon.7a26f1f7.svg";